import type { RefObject } from 'react';

export type PlayerState = 'idle' | 'loading' | 'playing' | 'paused' | 'ended' | 'error';

interface Props {
  video: RefObject<HTMLVideoElement | null>;
  /** Media URL of the current segment, undefined when nothing is loaded. */
  src: string | undefined;
  /** Seconds into the segment where the current position is. */
  onTime: (seconds: number) => void;
  /** Metadata is available: the owner applies the pending offset and plays. */
  onLoaded: (el: HTMLVideoElement) => void;
  onEnded: () => void;
  onState: (s: PlayerState) => void;
}

/**
 * The video element of the playback page. It only reports events; which
 * segment plays and where is decided by the page in event handlers, so the
 * one-minute segments play as one continuous recording.
 */
export function Player({ video, src, onTime, onLoaded, onEnded, onState }: Props) {
  return (
    <video
      ref={video}
      src={src}
      className="size-full bg-black object-contain"
      playsInline
      muted
      preload="auto"
      aria-label="Gravação"
      onLoadedMetadata={(e) => {
        onLoaded(e.currentTarget);
      }}
      onTimeUpdate={(e) => {
        onTime(e.currentTarget.currentTime);
      }}
      onPlaying={() => {
        onState('playing');
      }}
      onPause={(e) => {
        if (!e.currentTarget.ended) onState('paused');
      }}
      onWaiting={() => {
        onState('loading');
      }}
      onEnded={onEnded}
      onError={() => {
        if (src) onState('error');
      }}
    />
  );
}
